import Authenticator from "./authentication-authenticator";

export const USER_UPDATE = "Authentication/User/Update";
export const USER_UPDATE_TELEPHONE = "Authentication/User/Update/Telephone";
export const USER_UPDATE_EMAIL = "Authentication/User/Update/Email";
export const USER_ERROR = "Authentication/Error";
export const AUTH_UPDATE = "Authentication/Auth/Update";

const userUpdate = user => ({
    type: USER_UPDATE,
    payload: { user: user }
});

const userUpdateAttr = (attr, value) => ({
    type: USER_UPDATE,
    payload: { user: { [attr]: value } }
});

const userUpdateTelephone = value => ({
    type: USER_UPDATE_TELEPHONE,
    payload: { telephone: value }
});

const userUpdateEmail = value => ({
    type: USER_UPDATE_EMAIL,
    payload: { email: value }
});

const userRegister = user => {
    return async (dispatch, getState) => {
        const auth = new Authenticator();
        dispatch({
            type: AUTH_UPDATE,
            payload: {
                user: {},
                auth: {
                    loading: true
                }
            }
        });
        try {
            const registering =
                getState().authentication.auth.registering || [];
            if (!registering.includes(user.username)) {
                await auth.signUp(user);
                registering.push(user.username);
                dispatch({
                    type: AUTH_UPDATE,
                    payload: {
                        user,
                        auth: {
                            phone_number_verified: false,
                            phone_number_verification_sent: true,
                            loading: false,
                            registering
                        }
                    }
                });
            } else {
                dispatch({
                    type: AUTH_UPDATE,
                    payload: {
                        user,
                        auth: {
                            phone_number_verified: false,
                            phone_number_verification_sent: true,
                            loading: false
                        }
                    }
                });
            }
        } catch (error) {
            if (error.code === "UsernameExistsException") {
                try {
                    await dispatch(loadSession());
                    dispatch({
                        type: AUTH_UPDATE,
                        payload: {
                            user,
                            auth: {
                                phone_number_verified: false,
                                phone_number_verification_sent: true,
                                loading: false
                            }
                        }
                    });
                } catch (e) {
                    dispatch(userError(e));
                }
            } else {
                console.debug("userRegister error", error);
                dispatch({
                    type: AUTH_UPDATE,
                    payload: {
                        user: {},
                        auth: {
                            loading: false
                        }
                    }
                });
                dispatch(userError(error));
            }
        }
    };
};

const userSubmitEmail = user => {
    return async dispatch => {
        const auth = new Authenticator();
        dispatch({
            type: AUTH_UPDATE,
            payload: {
                user: {},
                auth: {
                    loading: true
                }
            }
        });
        try {
            await auth.updateUserEmail(user);
            // await auth.sendEmailVerification(user);
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    user: {},
                    auth: {
                        email_verified: false,
                        email_verification_sent: true,
                        loading: false
                    }
                }
            });
        } catch (error) {
            console.debug("userRegister error", error);
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    user: {},
                    auth: {
                        loading: false
                    }
                }
            });
            dispatch(userError(error));
        }
    };
};

const authUpdate = (user, auth) => ({
    type: AUTH_UPDATE,
    payload: {
        user,
        auth
    }
});

const resetTelephoneVerification = () => ({
    type: AUTH_UPDATE,
    payload: {
        auth: {
            phone_number_verification_sent: false
        }
    }
});

const resetTelephoneVerificationResent = () => ({
    type: AUTH_UPDATE,
    payload: {
        auth: {
            phone_number_verification_resent: false
        }
    }
});

const resendTelephoneVerification = user => {
    return async dispatch => {
        const auth = new Authenticator();
        dispatch({
            type: AUTH_UPDATE,
            payload: {
                user: {},
                auth: {
                    loading: true
                }
            }
        });
        try {
            await auth.resendTelephoneVerification(user);
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    auth: {
                        phone_number_verification_resent: true,
                        loading: false
                    }
                }
            });
        } catch (error) {
            console.debug("resendTelephoneVerification error", error);
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    user: {},
                    auth: {
                        loading: false
                    }
                }
            });
            dispatch(userError(error));
        }
    };
};

const confirmTelephoneVerification = (user, code) => {
    return async dispatch => {
        const auth = new Authenticator();
        dispatch({
            type: AUTH_UPDATE,
            payload: {
                user: {},
                auth: {
                    loading: true
                }
            }
        });
        try {
            await auth.confirmTelephoneVerification(user, code);
            await auth.signIn(user);
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    user: {},
                    auth: {
                        phone_number: user.username,
                        phone_number_verified: true,
                        loading: false
                    }
                }
            });
        } catch (error) {
            console.debug("confirmTelephoneVerification error", error);
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    user: {},
                    auth: {
                        loading: false
                    }
                }
            });
            dispatch(userError(error));
        }
    };
};

const resetEmailVerification = () => ({
    type: AUTH_UPDATE,
    payload: {
        auth: {
            email_verification_sent: false
        }
    }
});

const resetEmailVerificationResent = () => ({
    type: AUTH_UPDATE,
    payload: {
        auth: {
            email_verification_resent: false
        }
    }
});

const resendEmailVerification = user => {
    return async dispatch => {
        const auth = new Authenticator();
        dispatch({
            type: AUTH_UPDATE,
            payload: {
                user: {},
                auth: {
                    loading: true
                }
            }
        });
        try {
            await auth.sendEmailVerification(user);
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    auth: {
                        email_verification_resent: true,
                        loading: false
                    }
                }
            });
        } catch (error) {
            console.debug("resendEmailVerification error", error);
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    user: {},
                    auth: {
                        loading: false
                    }
                }
            });
            dispatch(userError(error));
        }
    };
};

const confirmEmailVerification = user => {
    return async dispatch => {
        const auth = new Authenticator();
        dispatch({
            type: AUTH_UPDATE,
            payload: {
                user: {},
                auth: {
                    loading: true
                }
            }
        });
        try {
            await auth.confirmEmailVerification(user);
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    user: {},
                    auth: {
                        email: user.email.address,
                        email_verified: true,
                        loading: false
                    }
                }
            });
        } catch (error) {
            console.debug("confirmEmailVerification error", error);
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    user: {},
                    auth: {
                        loading: false
                    }
                }
            });
            dispatch(userError(error));
        }
    };
};

const userError = error => ({
    type: USER_ERROR,
    payload: {
        error: error.message ? `${error.message}` : `${error}`
    }
});

const loadSession = () => {
    return async dispatch => {
        dispatch({
            type: AUTH_UPDATE,
            payload: {
                user: {},
                auth: {
                    loading: true
                }
            }
        });
        try {
            const currentUser = await new Authenticator().getCurrentUser();
            const { attributes } = currentUser;
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    user: {
                        username: attributes.phone_number,
                        firstname: attributes.nickname,
                        created: attributes["custom:created"],
                        email: {
                            address: attributes.email
                        },
                        telephone: {
                            international: attributes.phone_number
                        }
                    },
                    auth: {
                        phone_number: attributes.phone_number,
                        phone_number_verified: attributes.phone_number_verified,
                        email: attributes.email,
                        email_verified: attributes.email_verified,
                        loading: false
                    }
                }
            });
        } catch (error) {
            console.debug(error);
            dispatch({
                type: AUTH_UPDATE,
                payload: {
                    user: {},
                    auth: {
                        loading: false
                    }
                }
            });
            throw new Error("Unable to load session");
        }
    };
};

export {
    userUpdate,
    userUpdateAttr,
    userUpdateTelephone,
    userUpdateEmail,
    userSubmitEmail,
    userRegister,
    authUpdate,
    resetTelephoneVerification,
    resendTelephoneVerification,
    resetTelephoneVerificationResent,
    confirmTelephoneVerification,
    resetEmailVerification,
    resendEmailVerification,
    resetEmailVerificationResent,
    confirmEmailVerification,
    userError,
    loadSession
};
